import { useState, useEffect, useRef } from 'react';
import { AlertCircle, CheckCircle2, TrendingUp } from 'lucide-react';

export default function ManifestoBand({ title, eyebrow, dark = false, size = 'md', variant }) {
  const headingSize = size === 'lg' ? 'text-2xl md:text-4xl' : 'text-xl md:text-3xl';
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const words = (title || '').split(' ');

  const v = variant || (eyebrow === 'La solución' ? 'solution' : eyebrow === 'El resultado' ? 'result' : 'alert');

  return (
    <section ref={sectionRef} className={`w-full py-16 md:py-24 ${dark ? 'bg-brand-dark' : 'bg-gray-50'}`}>
      <div className="max-w-4xl mx-auto px-6 text-center">
        {eyebrow && (
          <p className={`text-xs font-semibold uppercase tracking-[0.25em] mb-5 flex items-center justify-center gap-1.5 ${
            v === 'solution' ? 'text-brand-green' :
            v === 'result' ? 'text-brand-blue' :
            'text-red-500'
          }`}>
            {v === 'solution' ? <CheckCircle2 size={14} className="shrink-0" /> :
             v === 'result' ? <TrendingUp size={14} className="shrink-0" /> :
             <AlertCircle size={14} className="shrink-0" />}
            {eyebrow}
          </p>
        )}
        <p className={`font-heading font-light leading-[1.25] tracking-tight text-balance ${headingSize} ${dark ? 'text-white' : 'text-gray-900'}`}>
          {words.map((word, i) => (
            <span
              key={i}
              className="inline-block transition-all duration-700 ease-out will-animate"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: `${i * 60}ms`,
              }}
            >
              {word}{i < words.length - 1 ? '\u00A0' : ''}
            </span>
          ))}
        </p>
        <div className={`mx-auto mt-8 h-px w-24 transition-all duration-700 ${visible ? 'opacity-100' : 'opacity-0'} ${dark ? 'bg-white/15' : 'bg-gray-200'}`} />
      </div>
    </section>
  );
}